import AppSystemResourcePagingResultModel from '../../generated/types/model/resource/AppSystemResourcePagingResultModel';

export default class AppSystemResourcePagingResultViewModel extends AppSystemResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
